import { createSlice } from '@reduxjs/toolkit';
import { createFirstMessage, replyMessage } from './operations';

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};
const handleRejected = (state, { payload }) => {
  state.isLoading = false;
  state.error = payload;
};
const initialState = {
  topicList: [],
  letters: {},
  currentTopic: null,
  isLoading: false,
  topicPagination: { page: 1, perPage: 20 },
};

export const sliceLetters = createSlice({
  name: 'Letters',
  initialState,
  reducers: {
    setCurrentTopic(state, { payload: userData }) {
      state.currentTopic = userData;
    },
    setLetters(state, { payload: userData }) {
      state.letters = userData;
    },
    setTopicItems(state, { payload: userData = [] }) {
      const array = userData.toSorted((el2, el1) => {
        const msgDate1 = el1?.lastMessage?.date || el1?.date;
        const msgDate2 = el2?.lastMessage?.date || el2?.date;
        return new Date(msgDate1) - new Date(msgDate2);
      });
      state.topicList = array;
    },
    setTopicPagination(state, { payload: userData }) {
      state.topicPagination = userData;
    },
    updateTopicCategory(state, { payload: { topicId, data } }) {
      const topicIndex = state.topicList.findIndex(el => el._id === topicId);
      if (topicIndex >= 0) {
        state.topicList[topicIndex] = {
          ...state.topicList[topicIndex],
          ...data,
        };
      }
    },

    updateLetter(state, { payload: userData }) {
      const { letterId, data, chatId } = userData;

      const letters = state.letters[chatId];
      console.log(letters);

      const index = letters.findIndex(el => el._id === letterId);

      if (index >= 0) {
        letters[index] = { ...letters[index], ...data };
      }
    },
  },

  extraReducers: builder => {
    builder
      .addCase(createFirstMessage.fulfilled, (state, { payload: userData }) => {
        state.isLoading = false;
        state.error = null;
        const existingIndex = state.topicList.findIndex(
          t => t._id === userData.topic._id,
        );

        if (existingIndex >= 0) {
          state.topicList[existingIndex] = userData.topic;
        } else {
          state.topicList = [userData.topic, ...state.topicList];
        }
        state.letters[userData.topic._id] = [userData.message];
        state.currentTopic = userData.topic._id;
      })
      .addCase(createFirstMessage.pending, handlePending)
      .addCase(createFirstMessage.rejected, handleRejected)
      .addCase(replyMessage.fulfilled, (state, { payload: letter }) => {
        state.isLoading = false;
        state.error = null;

        state.letters[letter.chatId].unshift(letter);
      })
      .addCase(replyMessage.pending, handlePending)
      .addCase(replyMessage.rejected, handleRejected);
  },
});

export const {
  setCurrentTopic,
  setLetters,
  updateTopicCategory,
  updateLetter,
  setTopicItems,
  setTopicPagination,
} = sliceLetters.actions;
export default sliceLetters.reducer;
